import { metrics as metricsDiagram } from '@process-advisor/process-miner/processMiner/processMiner';

export type Metrics = {
    value: string;
    label: string;
    type: string;
};

type Props = {}

export const metrics = ({}: Props): Metrics[] =>
    metricsDiagram();
